/**
 * DOM-Aufbau und TV-Animation für den Planet-Hub.
 * Delegiert Layout-Erstellung an PlanetMenuLayouts.ts.
 */
import { createHubHeader } from './PlanetHubHeader';
import * as UI from './UITheme';
import {
  mobileSidebarBtnStyle, desktopTabStyle,
  buildMobileLayout, buildDesktopLayout,
} from './PlanetMenuLayouts';

export const HUB_DELAY_MS = 1800;
export const HUB_TRANSITION_MS = 600;

export const REVEAL_KEYFRAMES: Keyframe[] = [
  { clipPath: 'inset(50% 50% 50% 50%)' },
  { clipPath: 'inset(50% 0 50% 0)', offset: 0.5 },
  { clipPath: 'inset(0 0 0 0)', offset: 1 },
];

export const HIDE_KEYFRAMES: Keyframe[] = [
  { clipPath: 'inset(0 0 0 0)' },
  { clipPath: 'inset(50% 0 50% 0)', offset: 0.5 },
  { clipPath: 'inset(50% 50% 50% 50%)', offset: 1 },
];

export type TabId = 'buildings' | 'research' | 'fleet';

export interface PlanetHubDOMResult {
  el: HTMLDivElement;
  contentWrap: HTMLDivElement;
  titleEl: HTMLSpanElement;
  hubHeaderEl: HTMLDivElement;
  tabsEl: HTMLDivElement;
  contentEl: HTMLDivElement;
  getTabStyle: (id: TabId, active: TabId) => string;
}

export function createPlanetHubDOM(
  onClose: () => void,
  onTabClick: (id: TabId) => void,
  setHeaderEl: (el: HTMLDivElement) => void,
): PlanetHubDOMResult {
  const m = UI.isMobile();

  const el = document.createElement('div');
  Object.assign(el.style, {
    position: 'fixed', inset: '0',
    background: 'linear-gradient(180deg, rgba(3,5,15,0.88) 0%, rgba(5,8,18,0.82) 100%)',
    backdropFilter: 'blur(4px)',
    fontFamily: 'monospace', fontSize: UI.fontSm(), color: '#8cf',
    zIndex: '9999', display: 'none',
    flexDirection: m ? 'row' : 'column',
    pointerEvents: 'auto', overflow: 'hidden',
    clipPath: 'inset(50% 50% 50% 50%)',
  });

  const hubHeaderEl = createHubHeader();
  setHeaderEl(hubHeaderEl);

  const titleEl = document.createElement('span');
  const tabsEl = document.createElement('div');
  const contentEl = document.createElement('div');
  let contentWrap: HTMLDivElement;

  if (m) {
    contentWrap = buildMobileLayout(el, titleEl, hubHeaderEl, tabsEl, contentEl, onClose, onTabClick);
  } else {
    contentWrap = buildDesktopLayout(el, titleEl, hubHeaderEl, tabsEl, contentEl, onClose, onTabClick);
  }

  const getTabStyle = m
    ? (id: TabId, active: TabId) => mobileSidebarBtnStyle(id === active)
    : (id: TabId, active: TabId) => desktopTabStyle(id === active);

  return { el, contentWrap, titleEl, hubHeaderEl, tabsEl, contentEl, getTabStyle };
}
